/* eslint-disable */

/**
 * @see https://gcp.baslerweb.com/jira/browse/DBP-2008
 * Prevent nuxt-prometheus module to patch fetch many times
 */
export default defineNuxtPlugin(() => {
  const globalAny = globalThis as any;

  if (globalAny.__PROMETHEUS_FETCH_PATCHED__) {
    return;
  }

  globalAny.__PROMETHEUS_FETCH_PATCHED__ = true;

  console.log('[Prometheus Guard] fetch patch allowed');
});
